import { createIcon } from "@chakra-ui/react";

export const Error = createIcon({
  displayName: "Error",
  viewBox: "0 0 24 24",
  d: "M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24zm0-18c.623 0 1.125.502 1.125 1.125v5.25c0 .623-.502 1.125-1.125 1.125a1.122 1.122 0 0 1-1.125-1.125v-5.25C10.875 6.502 11.377 6 12 6zm-1.5 10.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0z",
  defaultProps: {
    "aria-label": "An exclamation mark within a circle"
  }
});

export default Error;
